import { Box, BoxProps, chakra, keyframes } from '@chakra-ui/react';

const stroke = keyframes`
  100% {
    stroke-dashoffset: 0;
  }
`;

const scale = keyframes`
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
`;

export const TransferSuccessIcon = (boxProps: BoxProps) => (
  <Box {...boxProps}>
    <chakra.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 282 222"
      animation={`${scale} .3s ease-in-out .9s both;`}
    >
      <defs>
        <radialGradient
          id="gradient"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(110.314 63.9925) rotate(-133.645) scale(144.85 505.066)"
        >
          <stop stopColor="#0D7EC4" />
          <stop offset="0.166667" stopColor="#139EDD" />
          <stop offset="0.317708" stopColor="#BBDBFF" />
          <stop offset="0.484375" stopColor="#FEA514" />
          <stop offset="0.583333" stopColor="#FF4539" />
          <stop offset="0.6875" stopColor="#FF5544" />
          <stop offset="0.8125" stopColor="#FF6A9A" />
          <stop offset="0.895833" stopColor="#BBDBFF" />
          <stop offset="1" stopColor="#0D7EC4" />
        </radialGradient>
      </defs>

      <chakra.path
        transformOrigin={'50% 50%'}
        animation={`${stroke} 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards`}
        fill="none"
        stroke="url(#gradient)"
        strokeDasharray="400"
        strokeDashoffset="400"
        strokeWidth="24.1877"
        strokeLinejoin="round"
        d="M7.88477 114.911L92.8813 209.045L273.986 8.47366"
      />
    </chakra.svg>
  </Box>
);
